import type { ReactElement, ReactFragment } from 'react'
import type { Option } from '../../types'
import type { FormErrors, FormFields } from './formFields'

import { FormProvider } from '@workwave-tidal/form-ui/layout/FormProvider'

import { useController } from '../../hooks/useController'

import { useOptions } from './fields/Topic/hooks/useOptions'
import { formFields } from './formFields'
import { useFormConfig } from './hooks/useFormConfig'

interface Props {
  children: ReactFragment | ReactElement
}

export function TicketFormProvider(props: Props) {
  const {
    data: { ticket },
  } = useController()

  const options = useOptions()

  let topicValue: Option | null = null

  if (ticket.topic) {
    const matchingOption = options.find(
      option => option.type === 'option' && option.value === ticket.topic,
    )
    topicValue = matchingOption || null
  }

  const formConfig = useFormConfig({
    topic: topicValue,
    message: ticket.message ?? '',
    successMessage: ticket.successMessage ?? '',
  })

  return (
    <FormProvider<FormFields, FormErrors>
      name="open-support-ticket-form"
      fields={formFields}
      verbose={false}
      config={formConfig}
    >
      {props.children}
    </FormProvider>
  )
}
